<template lang="pug">

  div(class="firma-dialog-container")

    //- HEADER
    CustomDialogHeaderComponent(:headerTitle="texts.title")

    p(class="explanation") {{ texts.explanation }}

    InfoBarComponent(
       v-if="!isDMSUser"
      :infoText="texts.infoText"
    )

    span(class="required-fields-advice-base") {{ $t('components.form_generator.required_fields') }}

    //- FIELDS
    ReceiverFieldSelectComponent(
       v-if="!isDMSUser"
      @emit-receiver="setReceiver"
    )

    ValidationObserver(
        v-if="isDMSUser"
        ref="emailInput"
        v-slot="{ validate }"
      )

      LexonTextFieldComponent(
        v-model="email"
        label="Email"
        id="email"
        name="email"
        type="text"
        validationRules="required|email"
        @input="validateField"
      )

    LexonSwitchComponent(
      v-model="firmaSwitch"
      class="switch-field"
      id="switch"
      :label="texts.firmaSwitchLabel"
      name="switch"
      hide-details
    )

    //- BUTTONS
    CustomDialogActionButtonsComponent(
      :disabledButtons="disabledActionButton"
      :mainAction="signFirma"
      :primaryButtonText="texts.primaryButtonText"
    )

    //- SPINNER
    SpinnerLayerComponent(v-if="loadingSpinner" class="spinner-layer" :loadingText="spinnerText.sending")

</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import FirmaDialogsMixin from '@/mixins/firma/FirmaDialogsMixin.vue'
import { ValidationObserver } from 'vee-validate'

@Component({
  components: {
    CustomDialogActionButtonsComponent: () =>
      import('@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'),
    CustomDialogHeaderComponent: () => import('@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'),
    InfoBarComponent: () => import('@/components/InfoBar/InfoBarComponent.vue'),
    LexonTextFieldComponent: () => import('@/components/forms/fields/LexonTextField/LexonTextFieldComponent.vue'),
    LexonSwitchComponent: () => import('@/components/forms/fields/LexonSwitch/LexonSwitchComponent.vue'),
    ReceiverFieldSelectComponent: () =>
      import('@/components/Dialog/customDialogs/firma/ReceiverFieldSelectComponent.vue'),
    SpinnerLayerComponent: () => import('@/components/Spinner/SpinnerLayerComponent.vue'),
    ValidationObserver
  }
})
export default class SendToFirmaDialogComponent extends Mixins(FirmaDialogsMixin) {
  email = ''
  texts = {
    explanation: this.$t('components.firma_dialogs.send_to_firma.explanation'),
    firmaSwitchLabel: this.$t('components.firma_dialogs.send_to_firma.firma_switch'),
    primaryButtonText: this.$t('action_buttons.send'),
    title: this.$t('components.firma_dialogs.send_to_firma.title'),
    infoText: this.$t('components.firma_dialogs.send_certified_email.info_text')
  }

  showInfoBar = false

  $refs!: {
    emailInput: InstanceType<typeof ValidationObserver>
  }

  mounted() {
    if (this.isDMSUser) {
      this.texts.explanation = this.$t('components.firma_dialogs.send_to_firma.explanation_dms')
    }
  }

  async validateField() {
    await this.$nextTick()
    const fieldValid = await this.$refs.emailInput.validate()
    if (fieldValid) {
      this.setReceiver(this.email)
    } else {
      this.setReceiver('')
    }
  }
}
</script>
